import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
// import { PortalNavigationModule } from './modules/navigation/index';
import { NxiNavigationModule } from '@pershing/nxi-navigation';
import { PortalComponentsModule } from '@pershing/nxi-portalcomponents';
import { PortalRoutingModule } from './modules/app.routing.module';
import { PortalAppComponent } from './components/portal.component';
import { NxiPortalCoreModule } from '@pershing/nxi-core';
import { NxiAuthService } from './services/nxi-auth.service';
import { PortalAuthGuard } from './services/portal-authguard';
import { PortalComponentService } from './services/portal-component-service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NxiCommonModule } from '@pershing/nxi-common';
import { PershingCoreRootModule, PermissionCheckerService, IAuthorizationService } from '@pershing/pershing-core';
import { MCVModule } from '@pershing/nxi-ng-portfolio';
import { PortalAuthorizationServiceDefinition } from './services/portal-authorization-service-definition';
import { registerLocaleData } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { EDCEDeliveryModule } from '@pershing/edc-edelivery';
import localeEs from '@angular/common/locales/es';
import { NgSelectModule } from '@ng-select/ng-select';
import { NxiModernNavigationModule } from '@pershing/nxi-ng-modern-navigation';
import { EDCNewEDeliveryModule } from '@pershing/edc-newedelivery';


registerLocaleData(localeEs, 'es');

export function initUserRoles(
    permissionCheckerService: PermissionCheckerService,
    portalAuthorizationServiceDefinition: PortalAuthorizationServiceDefinition): () => Promise<any> {
    if (window['appSettings'].isLoggedIn) {
        return () => permissionCheckerService.init(portalAuthorizationServiceDefinition);
    } else {
        return () => null;
    }
}

export const COMPONENTS =[
    PortalAppComponent
];

export const PROVIDERS = [
    PortalAuthGuard,
    NxiAuthService,
    PortalComponentService
            //  { provide: 'AppSettings', useValue: (window as any).pershingAppSettings },
            //  { provide: MAT_LABEL_GLOBAL_OPTIONS, useValue: { float: 'never' } }
             //{ provide: APP_INITIALIZER, useFactory: initUserRoles, multi: true, deps: [IAuthorizationService] }
];

@NgModule({
    imports: [
        // This will be moved to app specific
        // common module and appsepcific common module will be
        // imported here
        PershingCoreRootModule,
        NxiPortalCoreModule.forRoot(),
        NxiCommonModule,
        BrowserAnimationsModule,
        RouterModule,
        HttpClientModule,
        PortalComponentsModule,
        // PortalNavigationModule,
        NxiNavigationModule,
        PortalRoutingModule,
        NgIdleKeepaliveModule.forRoot(),
        HttpClientJsonpModule,
        MCVModule,
        MatDialogModule,
        MatCardModule,
        EDCEDeliveryModule,
        NgSelectModule,
        NxiModernNavigationModule,
        EDCNewEDeliveryModule
    ],
    declarations: [ ...COMPONENTS ],
    exports: [ ...COMPONENTS ],
    entryComponents: [ ...COMPONENTS ],
    providers: [ ...PROVIDERS ],
    bootstrap: [ PortalAppComponent ]
})
export class NxiPortalCommonModule { }
